import React, { useEffect } from 'react';
import { MDBCol, MDBRow } from 'mdb-react-ui-kit';
import axios from '../../utils/axiosConfig';
import '../../Pages/Css/ordenesCompras.css';
import { formattedGlobalDate } from '../../utils/formattedDates';

// jQuery datetimepicker
import $ from 'jquery';
import 'jquery-datetimepicker/build/jquery.datetimepicker.full.min';
import 'jquery-datetimepicker/build/jquery.datetimepicker.min.css';
import Swal from 'sweetalert2';
import Select from 'react-select';

const selectStyles = {
    control: (base, state) => ({
        ...base,
        minHeight: '38px',
        borderColor: state.isFocused ? '#86b7fe' : '#cfe0f0',
        boxShadow: state.isFocused ? '0 0 0 0.2rem rgba(13, 110, 253, 0.2)' : 'none',
        '&:hover': { borderColor: '#86b7fe' },
    }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    menu: (base) => ({ ...base, zIndex: 9999 }),
};

const SearchableSelect = ({ id, value, onChange, options }) => {
    const selectedOption = options.find((option) => String(option.value) === String(value)) || null;

    return <Select
        inputId={id}
        classNamePrefix="oc-search-select"
        options={options}
        value={selectedOption}
        onChange={(selected) => onChange(selected?.value || '')}
        placeholder="Seleccione o busque..."
        noOptionsMessage={() => 'Sin coincidencias'}
        isClearable
        isSearchable
        aria-required="true"
        styles={selectStyles}
        menuPortalTarget={typeof document !== 'undefined' ? document.body : undefined}
        menuPosition="fixed"
    />;
};

const FormOrdenesCompras = ({ fklokSolicitud, bitOpens, bitCreates, bitEdits, bitDeletes }) => {
    // ----------------- Helpers -----------------
    const fmtLocal = (d = new Date()) => {
        const pad = (n) => String(n).padStart(2, '0');
        const y = d.getFullYear();
        const m = pad(d.getMonth() + 1);
        const day = pad(d.getDate());
        const hh = pad(d.getHours());
        const mm = pad(d.getMinutes());
        // Formato requerido por jquery-datetimepicker: "YYYY-MM-DD HH:mm"
        return `${y}-${m}-${day} ${hh}:${mm}`;
    };

    const [sortBy, setSortBy] = React.useState('');
    const [sortDirection, setSortDirection] = React.useState('asc');

    const renderSortIcon = (column) => {
        if (sortBy === column) {
            if (sortDirection === "asc") {
                return <span>&uarr;</span>; // Icono de flecha hacia arriba
            } else {
                return <span>&darr;</span>; // Icono de flecha hacia abajo
            }
        }
        return null; // No mostrar ningún ícono si no está ordenado por esta columna
    }

    // ----------------- State -----------------
    const [idOC, setIDOC] = React.useState('');
    const [empresaId, setEmpresaId] = React.useState('');
    const [acompananteId, setAcompananteId] = React.useState('');
    const [selectedTipoCategoria, setSelectedTipoCategoria] = React.useState('');
    const [fklokSolicitudID, setFklokSolicitudID] = React.useState(fklokSolicitud || '');
    const [ciudadOrigenId, setCiudadOrigenId] = React.useState('');
    const [ciudadDestinoId, setCiudadDestinoId] = React.useState('');
    const [observacion, setObservacion] = React.useState('');
    const [ordenesCompras, setOrdenesCompras] = React.useState([]);

    const [listEmpresass, setListEmpresas] = React.useState([]);
    const [listCategoriasOC, setListCategoriasOC] = React.useState([]);
    const [listCiudades, setListCiudades] = React.useState([]);
    const [listAcompanantes, setListAcompanantes] = React.useState([]);



    const [updating, setUpdating] = React.useState(false); // para distinguir entre insertar y actualizar

    const [dates, setDates] = React.useState({
        busqueda: '', // Fecha/Hora búsqueda
        fin: ''       // Fecha/Hora fin
    });

    // refs para jQuery datetimepicker
    const fechaHoraBusquedaRef = React.useRef(null);
    const fechaHoraFinRef = React.useRef(null);

    // ----------------- API -----------------
    const listEmpresas = async () => {
        try {
            const res = await axios.post(
                process.env.REACT_APP_SERVER + '/operaciones2/getempresasbusqueda',
                {},
                { headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${localStorage.getItem('tkn')}` }, withCredentials: true }
            );
            console.log('Empresas:', res?.data?.data?.recordset ?? []);
            setListEmpresas(res?.data?.data?.recordset ?? []);
        } catch (error) {
            console.error('Error fetching empresas:', error);
        }
    };

    const listCategoriesOC = async () => {
        try {
            const res = await axios.post(
                process.env.REACT_APP_SERVER + '/operaciones2/getcategoriasoc',
                {},
                { headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${localStorage.getItem('tkn')}` }, withCredentials: true }
            );
            console.log('Categorías de OC:', res?.data?.data?.recordset ?? []);
            setListCategoriasOC(res?.data?.data?.recordset ?? []);
        } catch (error) {
            console.error('Error fetching categories:', error);
        }
    };

    const listGetCiudades = async () => {
        try {
            const res = await axios.post(
                process.env.REACT_APP_SERVER + '/operaciones2/getciudades',
                {},
                { headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${localStorage.getItem('tkn')}` }, withCredentials: true }
            );
            console.log('Ciudades:', res?.data?.data?.recordset ?? []);
            setListCiudades(res?.data?.data?.recordset ?? []);
        } catch (error) {
            console.error('Error fetching cities:', error);
        }
    };

    const listGetAcompanantes = async () => {
        try {
            const res = await axios.post(
                process.env.REACT_APP_SERVER + '/operaciones2/getacompanantes',
                {},
                { headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${localStorage.getItem('tkn')}` }, withCredentials: true }
            );
            setListAcompanantes(res?.data?.data?.recordset ?? []);
        } catch (error) {
            console.error('Error fetching acompanantes:', error);
        }
    };

    const getNumOrdenCompra = async () => {
        console.log('Obteniendo número de orden de compra...');
        const res = await axios.get(
            `${process.env.REACT_APP_SERVER}/operaciones2/getnumordencompra`,
            { headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${localStorage.getItem('tkn')}` }, withCredentials: true }
        );
        const numero = res?.data?.data?.recordset?.[0]?.num;
        setIDOC(numero ?? '');
        return numero;
    };

    const getOrdenesCompras = async () => {
        let data = {
            idsolicitud: fklokSolicitud
        }
        try {
            const res = await axios.post(
                process.env.REACT_APP_SERVER + '/operaciones2/getordenescompra',
                JSON.stringify(data),
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${localStorage.getItem('tkn')}`
                    }, withCredentials: true
                }
            );
            console.log('Órdenes de compra obtenidas:', res?.data?.data?.recordsets);
            setOrdenesCompras(res?.data?.data?.recordsets ?? []);
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'No se pudieron cargar las órdenes de compra.'
            });
            console.error('Error fetching ordenes de compras:', error);
        }
    };

    // Helpers para búsquedas por id (con normalización a string)
    const byId = (arr, key, label) => {
        const map = new Map(arr.map(x => [String(x[key]), x[label]]));
        return (id) => map.get(String(id)) ?? "";
    };

    const findEmpresa = byId(listEmpresass, "IDEmpresasOC", "Descripcion");
    const findAcompanante = byId(listAcompanantes, "IDAcompaniante", "Nombre");
    const findCategoria = byId(listCategoriasOC, "id_categoria_oc", "desc_categoria_oc");

    // Acepta array o objeto suelto
    const toArray = (d) => Array.isArray(d) ? d : (d ? [d] : []);

    const loadFillData = (rows) => {
        const items = toArray(rows);
        // console.log('Renderizando filas, items:', items[0]);
        if (!items.length) return null;

        return items[0].map((item) => (
            <tr key={item.NumOCBusqueda ?? item.ID ?? `${item.FKLokSolicitudID}-${item.FKLokEmpresaOC}`}>
                <td style={{ width: "200px" }}>{item.NumOCBusqueda}</td>
                <td style={{ width: "250px", textAlign: "center" }}>{findEmpresa(item.FKLokEmpresaOC)}</td>
                <td style={{ width: "250px", textAlign: "center" }}>{findAcompanante(item.FKLokAcompanianteOC)}</td>
                <td style={{ width: "150px", textAlign: "center" }}>{findCategoria(item.FKLokCategoriaOC)}</td>
                <td style={{ width: "250px", textAlign: "center" }}>{item.ciudadorigen}</td>
                <td style={{ width: "250px", textAlign: "center" }}>{item.ciudaddestino}</td>
                <td style={{ width: "250px", textAlign: "center" }}>{formattedGlobalDate(item.FechaCita)}</td>
                <td style={{ width: "250px", textAlign: "center" }}>{formattedGlobalDate(item.FechaFin) || ""}</td>
                <td style={{ width: "150px", textAlign: "center" }}>{item.Observaciones}</td>
                {<td style={{ width: "20px" }}>
                    <i
                        className="bx bxs-pencil bx-tada"
                        style={{ 
                            color: bitEdits ? "#006699" : "#cccccc", 
                            cursor: bitEdits ? "pointer" : "not-allowed", 
                            padding: "4px" 
                        }}
                        onClick={bitEdits ? () => handleUpdate(item) : undefined}
                    />
                </td>}
            </tr>
        ));
    };



    // ----------------- Effects -----------------
    // Cargar catálogos
    React.useEffect(() => {
        listEmpresas();
        listCategoriesOC();
        listGetCiudades();
        listGetAcompanantes();
        getOrdenesCompras();
    }, []);

    // Establecer valores iniciales de fechas (busqueda = ahora, fin = vacío)
    React.useEffect(() => {
        setDates({ busqueda: fmtLocal(), fin: '' });
    }, []);

    // Inicializar jQuery datetimepickers
    React.useEffect(() => {
        if (!fechaHoraBusquedaRef.current || !fechaHoraFinRef.current) return;

        $.datetimepicker.setLocale('es');

        // BUSQUEDA: arranca con dates.busqueda o ahora
        $(fechaHoraBusquedaRef.current).datetimepicker({
            format: 'Y-m-d H:i',
            step: 30,
            value: dates.busqueda || fmtLocal(),
            timepicker: true,
            datepicker: true,
            onChangeDateTime: (_dp, $input) => {
                setDates(prev => ({ ...prev, busqueda: $input.val() }));
            }
        });

        // FIN: arranca vacío
        $(fechaHoraFinRef.current).datetimepicker({
            format: 'Y-m-d H:i',
            step: 30,
            value: dates.fin || '',
            timepicker: true,
            datepicker: true,
            onChangeDateTime: (_dp, $input) => {
                setDates(prev => ({ ...prev, fin: $input.val() }));
            }
        });

        // cleanup
        return () => {
            try { $(fechaHoraBusquedaRef.current).datetimepicker('destroy'); } catch { }
            try { $(fechaHoraFinRef.current).datetimepicker('destroy'); } catch { }
        };

    }, []); // solo al montar

    // ----------------- Handlers -----------------
    const validateRequiredFields = (values) => {
        const missingFields = [
            ['Empresa', values.empresa],
            ['Acompañante', values.acompanante],
            ['Categoría', values.categoria],
            ['Ciudad origen', values.origen],
            ['Ciudad destino', values.destino],
            ['Fecha/Hora búsqueda', values.busqueda],
            ['Fecha/Hora fin', values.fin],
            ['Observación', values.observacion?.trim()],
        ].filter(([, value]) => !String(value || '').trim()).map(([label]) => label);

        if (!missingFields.length) return true;

        Swal.fire({
            icon: 'warning',
            title: 'Campos obligatorios',
            html: `Complete los siguientes campos: <strong>${missingFields.join(', ')}</strong>.`,
        });
        return false;
    };

    const handleUpdate = async (item) => {
        setUpdating(true);
        console.log('Editar orden de compra:', item);
        const findCiudadOrigen = listCiudades.find(c => c.NombreCiudad === item.ciudadorigen);
        const findCiudadDestino = listCiudades.find(c => c.NombreCiudad === item.ciudaddestino);
        console.log('findCiudadOrigen', findCiudadOrigen);
        console.log('findCiudadDestino', findCiudadDestino);
        setCiudadOrigenId(findCiudadOrigen ? findCiudadOrigen.IDCiudad : '');
        setCiudadDestinoId(findCiudadDestino ? findCiudadDestino.IDCiudad : '');
        setIDOC(item.IdOCBusqueda);
        setFklokSolicitudID(item.FKLokSolicitudID);
        setEmpresaId(item.FKLokEmpresaOC);
        setAcompananteId(item.FKLokAcompanianteOC);
        setSelectedTipoCategoria(item.FKLokCategoriaOC);
        setObservacion(item.Observaciones);
        setDates({
            busqueda: formattedGlobalDate(item.FechaCita),
            fin: item.FechaFin ? formattedGlobalDate(item.FechaFin) : ''
        });

    };

    const handleSubmit2 = async (e) => {
        e?.preventDefault?.();
        const valBusqueda = dates.busqueda || $(fechaHoraBusquedaRef.current).val();
        const valFin = dates.fin || $(fechaHoraFinRef.current).val();
        if (!validateRequiredFields({
            empresa: empresaId, acompanante: acompananteId, categoria: selectedTipoCategoria,
            origen: ciudadOrigenId, destino: ciudadDestinoId, busqueda: valBusqueda,
            fin: valFin, observacion,
        })) return;
        console.log('Submit (stub)');
        const dataUpdate = {
            num: idOC,
            FKLokSolicitudID: fklokSolicitud,
            fklokempresaoc: empresaId,
            fkacompaniante: acompananteId,
            fkorigen: ciudadOrigenId,
            fkdestino: ciudadDestinoId,
            categoria: selectedTipoCategoria,
            observacion,
            horacita: valBusqueda,            // requerido
            horafin: valFin,
        }
        console.log('Data to update:', dataUpdate);
        try {
            await axios.post(
                process.env.REACT_APP_SERVER + '/operaciones2/setupdateordencompra',
                JSON.stringify(dataUpdate),
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${localStorage.getItem('tkn')}`
                    }, withCredentials: true
                }
            ).then(res => {
                console.log('Respuesta del servidor:', res);
                if (res?.data?.success) {
                    Swal.fire({
                        icon: 'success',
                        title: 'Orden de compra actualizada',
                        text: `La orden de compra ${idOC} ha sido actualizada exitosamente.`
                    });
                    // limpiar formulario
                    limpiarCampos();
                    getOrdenesCompras();
                }
            });
        } catch (err) {
            console.error('Error al enviar:', err);
        }
    };

    const handleSubmit = async (e) => {
        console.log('handleSubmit called');
        e.preventDefault();
        try {
            // respaldo: si por algún motivo el estado no tiene último valor, lee directamente del input del plugin
            const valBusqueda = dates.busqueda || $(fechaHoraBusquedaRef.current).val();
            const valFin = dates.fin || $(fechaHoraFinRef.current).val();

            if (!validateRequiredFields({
                empresa: empresaId, acompanante: acompananteId, categoria: selectedTipoCategoria,
                origen: ciudadOrigenId, destino: ciudadDestinoId, busqueda: valBusqueda,
                fin: valFin, observacion,
            })) return;

            const numeroOC = await getNumOrdenCompra();

            console.log('Valores a enviar:');
            console.log('Fecha/Hora búsqueda:', valBusqueda);
            console.log('Fecha/Hora fin:', valFin);

            const data = {
                num: numeroOC,
                FKLokSolicitudID: fklokSolicitud,
                fklokempresaoc: empresaId,
                fkacompaniante: acompananteId,
                fkorigen: ciudadOrigenId,
                fkdestino: ciudadDestinoId,
                categoria: selectedTipoCategoria,
                observacion,
                horacita: valBusqueda,            // requerido
                horafin: valFin,
            };

            console.log('Data to submit insertOrders:', data);
            await axios.post(
                process.env.REACT_APP_SERVER + '/operaciones2/setinsertordencompra',
                data,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${localStorage.getItem('tkn')}`
                    }, withCredentials: true
                }
            ).then(res => {
                console.log('Respuesta del servidor:', res);
                if (res?.data?.success) {
                    Swal.fire({
                        icon: 'success',
                        title: 'Orden de compra guardada',
                        text: `La orden de compra ${numeroOC} ha sido guardada exitosamente.`
                    });
                    // limpiar formulario
                    limpiarCampos();
                    getOrdenesCompras();
                }
            });
        } catch (err) {
            console.error('Error al enviar:', err);
        }
    };

    const handleDelete = (e) => {
        e.preventDefault();
        // tu lógica de borrado aquí      
        console.log('Eliminar (stub)');
    };

    const limpiarCampos = () => {
        setIDOC('');
        setEmpresaId('');
        setAcompananteId('');
        setSelectedTipoCategoria('');
        setCiudadOrigenId('');
        setCiudadDestinoId('');
        setObservacion('');
        setDates({ busqueda: fmtLocal(), fin: '' });
        setUpdating(false);
    }

    useEffect(()=>{
        if(fklokSolicitud) {
            console.log('fklokSolicitud changed, fetching ordenes de compra...', fklokSolicitud);
        }
    },[fklokSolicitud]);

    // ----------------- UI -----------------
    return (
        <>
            {bitOpens && (
                <>
                    <div className="form-card oc-compact oc-centered oc-modern-card">
                        <MDBRow className="gx-4 gy-3">
                            {/* COLUMNA IZQUIERDA */}
                            <MDBCol md="6">
                                {/* ID OC */}
                                <MDBRow className="g-2 align-items-center">
                                    <MDBCol md="4" className="text-md-end">
                                        <label className="Label" htmlFor="oc-id">ID</label>
                                    </MDBCol>
                                    <MDBCol md="8">
                                        <div className="oc-control">
                                            <input id="oc-id" className="Input" defaultValue={idOC} disabled />
                                        </div>
                                    </MDBCol>
                                </MDBRow>

                                {/* Empresa */}
                                <MDBRow className="g-2 align-items-center">
                                    <MDBCol md="4" className="text-md-end">
                                        <label className="Label" htmlFor="oc-empresa">Empresa</label>
                                    </MDBCol>
                                    <MDBCol md="8">
                                        <div className="oc-control">
                                            <SearchableSelect
                                                id="oc-empresa"
                                                value={empresaId}
                                                onChange={setEmpresaId}
                                                options={listEmpresass.map((empresa) => ({
                                                    value: empresa.IDEmpresasOC,
                                                    label: empresa.Descripcion,
                                                }))}
                                            />
                                        </div>
                                    </MDBCol>
                                </MDBRow>

                                {/* Acompañante */}
                                <MDBRow className="g-2 align-items-center">
                                    <MDBCol md="4" className="text-md-end">
                                        <label className="Label" htmlFor="oc-acomp">Acompañante</label>
                                    </MDBCol>
                                    <MDBCol md="8">
                                        <div className="oc-control">
                                            <SearchableSelect
                                                id="oc-acomp"
                                                value={acompananteId}
                                                onChange={setAcompananteId}
                                                options={listAcompanantes.map((acompanante) => ({
                                                    value: acompanante.IDAcompaniante,
                                                    label: acompanante.Nombre,
                                                }))}
                                            />
                                        </div>
                                    </MDBCol>
                                </MDBRow>

                                {/* Categoría */}
                                <MDBRow className="g-2 align-items-center">
                                    <MDBCol md="4" className="text-md-end">
                                        <label className="Label" htmlFor="oc-cat">Categoría</label>
                                    </MDBCol>
                                    <MDBCol md="8">
                                        <div className="oc-control">
                                            <SearchableSelect
                                                id="oc-cat"
                                                value={selectedTipoCategoria}
                                                onChange={setSelectedTipoCategoria}
                                                options={listCategoriasOC.map((categoria) => ({
                                                    value: categoria.id_categoria_oc,
                                                    label: categoria.desc_categoria_oc,
                                                }))}
                                            />
                                        </div>
                                    </MDBCol>
                                </MDBRow>

                                {/* Ciudad origen */}
                                <MDBRow className="g-2 align-items-center">
                                    <MDBCol md="4" className="text-md-end">
                                        <label className="Label" htmlFor="oc-origen">Ciudad origen</label>
                                    </MDBCol>
                                    <MDBCol md="8">
                                        <div className="oc-control">
                                            <SearchableSelect
                                                id="oc-origen"
                                                value={ciudadOrigenId}
                                                onChange={setCiudadOrigenId}
                                                options={listCiudades.map((ciudad) => ({
                                                    value: ciudad.IDCiudad,
                                                    label: ciudad.NombreCiudad,
                                                }))}
                                            />
                                        </div>
                                    </MDBCol>
                                </MDBRow>

                                {/* Ciudad destino */}
                                <MDBRow className="g-2 align-items-center">
                                    <MDBCol md="4" className="text-md-end">
                                        <label className="Label" htmlFor="oc-destino">Ciudad destino</label>
                                    </MDBCol>
                                    <MDBCol md="8">
                                        <div className="oc-control">
                                            <SearchableSelect
                                                id="oc-destino"
                                                value={ciudadDestinoId}
                                                onChange={setCiudadDestinoId}
                                                options={listCiudades.map((ciudad) => ({
                                                    value: ciudad.IDCiudad,
                                                    label: ciudad.NombreCiudad,
                                                }))}
                                            />
                                        </div>
                                    </MDBCol>
                                </MDBRow>
                            </MDBCol>

                            {/* COLUMNA DERECHA */}
                            <MDBCol md="6">
                                {/* Fecha/Hora búsqueda */}
                                <MDBRow className="g-2 align-items-center">
                                    <MDBCol md="4" className="text-md-end">
                                        <label className="Label" htmlFor="fechaHoraBusqueda">Fecha/Hora búsqueda</label>
                                    </MDBCol>
                                    <MDBCol md="8">
                                        <div className="oc-control">
                                            <input
                                                id="fechaHoraBusqueda"
                                                type="text"
                                                className="Input"
                                                ref={fechaHoraBusquedaRef}
                                                defaultValue={dates.busqueda} // jQuery actualizará
                                                readOnly
                                                required
                                            />
                                        </div>
                                    </MDBCol>
                                </MDBRow>

                                {/* Fecha/Hora fin */}
                                <MDBRow className="g-2 align-items-center">
                                    <MDBCol md="4" className="text-md-end">
                                        <label className="Label" htmlFor="fechaHoraFin">Fecha/Hora fin</label>
                                    </MDBCol>
                                    <MDBCol md="8">
                                        <div className="oc-control">
                                            <input
                                                id="fechaHoraFin"
                                                type="text"
                                                className="Input"
                                                ref={fechaHoraFinRef}
                                                required
                                                defaultValue={dates.fin} // empieza vacío
                                                readOnly
                                            />
                                        </div>
                                    </MDBCol>
                                </MDBRow>

                                {/* Observación */}
                                <MDBRow className="g-2 align-items-start">
                                    <MDBCol md="4" className="text-md-end">
                                        <label className="Label" htmlFor="observacionesServicio">Observación</label>
                                    </MDBCol>
                                    <MDBCol md="8">
                                        <div className="oc-control">
                                            <textarea
                                                id="observacionesServicio"
                                                className="TextAreaReportSe"
                                                rows={8}
                                                value={observacion}
                                                onChange={(e) => setObservacion(e.target.value)}
                                                required
                                            />
                                        </div>
                                    </MDBCol>
                                </MDBRow>
                            </MDBCol>
                        </MDBRow>

                        <MDBRow className="mt-3 mb-3 justify-content-center gap-3 oc-modern-actions">
                            {updating ? (
                                <button className="Button blue oc-modern-primary-btn" style={{ width: 120, cursor:"pointer" }} onClick={handleSubmit2} disabled={!bitEdits}>Actualizar</button>
                            ) : (
                                <button className="Button blue oc-modern-primary-btn" style={{ width: 120, cursor:"pointer" }} onClick={handleSubmit} disabled={!bitCreates}>Guardar</button>
                            )}
                            <button className="Button oc-modern-secondary-btn" style={{ width: 120 }} onClick={limpiarCampos}>Limpiar</button>
                        </MDBRow>
                    </div>
                    <MDBRow>
                        <MDBCol md={12}>
                            <div className="card ContainerTableReportesSolicitudes oc-modern-table-card" >
                                <div
                                    className="table-responsive text-nowrap oc-modern-table-responsive"
                                    style={{
                                        height: `calc(70vh - 300px)`,
                                        overflowY: "auto",
                                        overflowX: "auto",
                                        display: "block",


                                        // flexDirection: "column",
                                    }}
                                >
                                    <table className="table table-hover oc-modern-table-inner" id="tabla" style={{ overflowX: 'auto', width: "100%" }}>
                                        <thead className="FondoHeaderTabla2">
                                            <tr>

                                                <th
                                                    style={{ color: "#ffffff", width: '100px' }}
                                                // onClick={() => sortData("IDSolicitudes")}
                                                >
                                                    ID {renderSortIcon("IDSolicitudes")}
                                                </th>

                                                <th
                                                    style={{ color: "#ffffff", width: '250px', textAlign: 'center' }}
                                                // onClick={() => sortData("NombreEmpresa")}
                                                >
                                                    Empresa{" "}
                                                    {renderSortIcon("NombreEmpresa")}
                                                </th>
                                                <th
                                                    style={{ color: "#ffffff", width: '250px', textAlign: 'center' }}
                                                // onClick={() => sortData("NombreEmpresa")}
                                                >
                                                    Acompañante{" "}
                                                    {renderSortIcon("NombreAcompañante")}
                                                </th>
                                                <th
                                                    style={{ color: "#ffffff", width: '180px', textAlign: 'center' }}
                                                // onClick={() => sortData("NombreEmpresa")}
                                                >
                                                    Categoría{" "}
                                                    {renderSortIcon("NombreEmpresa")}
                                                </th>

                                                <th
                                                    style={{ color: "#ffffff", width: "250px", textAlign: 'center' }}
                                                // onClick={() => sortData("Ruta")}
                                                >
                                                    Ciudad origen {renderSortIcon("Ruta")}
                                                </th>
                                                <th
                                                    style={{ color: "#ffffff", width: "250px", textAlign: 'center' }}
                                                // onClick={() => sortData("Ruta")}
                                                >
                                                    Ciudad destino {renderSortIcon("Ruta")}
                                                </th>
                                                <th
                                                    style={{ color: "#ffffff", width: "250px", textAlign: 'center' }}
                                                // onClick={() => sortData("Ruta")}
                                                >
                                                    Fecha/Hora búsqueda {renderSortIcon("Ruta")}
                                                </th>
                                                <th
                                                    style={{ color: "#ffffff", width: "250px", textAlign: 'center' }}
                                                // onClick={() => sortData("Ruta")}
                                                >
                                                    Fecha/Hora fin {renderSortIcon("Ruta")}
                                                </th>

                                                <th
                                                    style={{ color: "#ffffff", width: "150px", textAlign: 'center' }}
                                                // onClick={() => sortData("PlacaTruck")}
                                                >
                                                    Observación {renderSortIcon("PlacaTruck")}
                                                </th>
                                                <th
                                                    style={{ color: "#ffffff", width: "20px" }}
                                                // onClick={() => sortData("IconSeguro")}
                                                >
                                                    {renderSortIcon("IconSeguro")}
                                                </th>



                                            </tr>
                                        </thead>
                                        <tbody className="table-border-bottom-0" id="tabladata">
                                            {loadFillData(ordenesCompras)}
                                            {/* el body */}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </MDBCol>
                    </MDBRow>
                </>
            )
            }
        </>
    );
};

export default FormOrdenesCompras;
